import { useEffect, useRef, useState } from 'react'

export function usePresence(visible, { exitMs = 160 } = {}) {
  const [mounted, setMounted] = useState(Boolean(visible))
  const [phase, setPhase] = useState(visible ? 'enter' : 'exit')
  const timerRef = useRef(null)

  useEffect(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
      timerRef.current = null
    }

    if (visible) {
      setMounted(true)
      setPhase('enter')
      return
    }

    if (!mounted) return
    setPhase('exit')
    timerRef.current = setTimeout(() => {
      setMounted(false)
      timerRef.current = null
    }, exitMs)
  }, [visible, exitMs, mounted])

  useEffect(() => {
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current)
    }
  }, [])

  return { mounted, phase }
}

